import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Text } from '@/components/ui/Typography/Body/Text';
const colors = {
    base: {
        bgColor: 'border-gray-300 bg-white',
        textColor: 'textGray',
    },
};
export const LargeTagOutline = (props) => {
    const { children, className = '', color = 'base', tagName = 'span' } = props;
    return (_jsx(Text, Object.assign({ className: clsx('border border-solid rounded-md', 'px-8 py-4', colors[color].bgColor, className), color: colors[color].textColor, size: 'md', tagName: tagName }, { children: children })));
};
export const tagColors = colors;
